// Devices
export const DESKTOP = 'desktop';
export const PHONE = 'phone';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';

// Paths
export const STATIC_IMAGE = '/static/images';
export const IMAGE_PLACEHOLDER = '/static/images/image-placeholder.png';
export const API_PROXY_PATH = '/api';
export const API_URLS = '/api';

// Environments
export const ENV_DEVELOPMENT = 'development';
export const ENV_PRODUCTION = 'production';

// Key Codes
export const KEY_ESCAPE = 27;
export const KEY_ENTER = 13;
export const KEY_TAB = 9;
export const KEY_SPACE = 32;
export const KEY_UP_CODE = 38;
export const KEY_LEFT_CODE = 37;
export const KEY_RIGHT_CODE = 39;
export const KEY_DOWN_CODE = 40;
export const API_ERROR_HANDLER_PAGE = '/error';

// HTTP Status
export const STATUS_ERROR = 'ERROR';
export const STATUS_SUCCESS = 'SUCCESS';
export const RESPONSE_OK = 200;
export const RESPONSE_SERVER_ERROR = 500;

// Locale
export const DEFAULT_LOCALE = 'en_GB';
export const LOCALE_COOKIE = 'LOCALE_INFO';
